module.exports = __webpack_public_path__ + "static/media/wab32_1019.e947e9e7.ico";